import React, { useState, useEffect } from "react";
import "./KakaoSharePage.css";

const KakaoSharePage: React.FC = () => {
  const [kakaoLoaded, setKakaoLoaded] = useState(false);

  // 1. SDK 로드
  useEffect(() => {
    if (window.Kakao) {
      setKakaoLoaded(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.5/kakao.min.js";
    script.async = true;
    script.onload = () => setKakaoLoaded(true);
    document.body.appendChild(script);
  }, []);

  // 카카오톡 공유 직접 호출
  const handleKakaoShare = (e: React.MouseEvent) => {
    e.preventDefault();
    if (kakaoLoaded && window.Kakao && window.Kakao.Share) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init("ce21a9a0584e402f42f6e9bc767aa4b9");
      }
      window.Kakao.Share.sendCustom({
        templateId: 121583,
        templateArgs: { REGI_WEB_DOMAIN: "https://wedding.j1n.uk" },
      });
    } else {
      alert(
        "카카오톡 공유 기능을 불러오는 중입니다. 잠시 후 다시 시도해 주세요."
      );
    }
  };

  return (
    <div className="kakao-share-page">
      <div className="share-container">
        <h1 className="share-title">카카오톡 공유하기</h1>
        <p className="share-description">
          소중한 분들과 함께하고 싶습니다
        </p>
        
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 16,
          }}
        >
          {/* 카카오톡 공유하기 버튼 */}
          <button
            id="kakaotalk-sharing-btn"
            type="button"
            onClick={handleKakaoShare}
            style={{
              display: "flex",
              alignItems: "center",
              background: "none",
              border: "none",
              padding: 0,
              margin: 0,
              cursor: "pointer",
              opacity: 0.85,
              transition: "opacity 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "1")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "0.85")}
          >
            <img
              src="https://developers.kakao.com/assets/img/about/logos/kakaotalksharing/kakaotalk_sharing_btn_medium.png"
              alt="카카오톡 공유 보내기 버튼"
              style={{
                marginRight: 8,
                width: 28,
                height: 28,
                borderRadius: 4,
                background: "none",
                boxShadow: "none",
              }}
            />
            <span
              style={{
                color: "#381e1f",
                fontWeight: 700,
                fontSize: 18,
                letterSpacing: -1,
              }}
            >
              카카오톡 공유하기
            </span>
          </button>
          {/* 사이트 주소 복사하기 버튼 */}
          <button
            type="button"
            onClick={() => {
              navigator.clipboard.writeText("https://wedding.j1n.uk");
              alert("주소가 복사되었습니다!");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              background: "none",
              border: "none",
              padding: 0,
              margin: 0,
              cursor: "pointer",
              opacity: 0.85,
              transition: "opacity 0.2s",
              gap: 6,
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "1")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "0.85")}
          >
            <svg width="22" height="22" fill="#3182f6" viewBox="0 0 20 20">
              <rect
                x="5"
                y="5"
                width="10"
                height="12"
                rx="2"
                fill="#3182f6"
                fillOpacity="0.13"
              />
              <rect
                x="7"
                y="3"
                width="10"
                height="12"
                rx="2"
                stroke="#3182f6"
                strokeWidth="2"
                fill="none"
              />
            </svg>
            <span
              style={{
                color: "#222",
                fontWeight: 700,
                fontSize: 18,
                letterSpacing: -1,
              }}
            >
              사이트 주소 복사하기
            </span>
          </button>
        </div>

        <div className="navigation-links">
          <a href="/" className="nav-link">메인 페이지</a>
          <a href="/old" className="nav-link">기존 페이지</a>
        </div>
      </div>
    </div>
  );
};

export default KakaoSharePage;
